import React from 'react'
import { Route, Switch, withRouter } from 'react-router-dom'
import { LOGIN } from './constants/menu_items'
import ReservationsInformation from './containers/ReservationsInformation'
import MainUser from './components/MainUser'
import Restaurants from './containers/Restaurants'
import VerificationEmail from './containers/VerificationEmail'
import HomeReservando from './components/HomeReservando'
import './App.css'
import RestaurantReserve from './components/RestaurantReserve'

const App = () => {
    return (
        <div className="App">
            {
                <Switch>
                    <Route path="/reservations" render={props => <ReservationsInformation/>}/>
                    <Route path="/restaurants/:id/reserve" render={props => <RestaurantReserve/>}/>
                    <Route path="/restaurants/:id" render={props => <RestaurantReserve/>}/>
                    <Route path="/VerificationEmail" render={props => <VerificationEmail/>}/>
                    <Route path={`/${LOGIN}`} render={props => <MainUser/>}/>
                    <Route path="/" render={props => <HomeReservando props={props}/>}/>
                </Switch>
            }
        </div>
    )
}

export default withRouter(App)